import Vue from 'vue'
import _ from 'lodash'

const keycloak = () => Vue.prototype.$keycloak

export const ROLE_USER = 'user'

export const keycloakService = {
  getToken() {
    return keycloak().token
  },

  hasRole(role) {
    return (
      !_.isNil(keycloak().hasResourceRole) &&
      keycloak().hasResourceRole(role, window.$appConfig.VUE_APP_KEYCLOAK_CLIENT_ID)
    )
  },

  logout() {
    return !_.isNil(keycloak().logoutFn) && keycloak().logoutFn()
  },

  fullName() {
    return keycloak().fullName
  }
}
